module.exports = __webpack_public_path__ + "static/media/BF.11f71efb.png";